<template>
   <vue-final-modal
      v-model="UpMedProviderModal"
      classes="UpMedProv-modal-modal-container"
      content-class="UpMedProv-modal-content"
      :click-to-close="false"
      @before-open="beforeOpen()"
      @opened="opened()"
   >
      <!--
      @click-outside="beforeClose()"
      @before-open="beforeOpen()"
      @opened="opened()"
      classes="modal-container"
      content-class="v310-modal-content"
      drag-selector=".drug-area"
      :drag="true"
      :click-to-close="false"
      -->
      <button 
            id="last"
            type="button"
            class="modal__close btn btn-sm" 
            :tabindex="currentLastTabIndex + 4" 
            @click="beforeClose()"
            >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white">Prestador {{dataMedProv.cuit}} {{dataMedProv.name}} ({{dataMedProv.branch}}) {{isUpdate ? "Modificación" : "Nuevo"}}</span>

      <div class="up-medProv border-top p-1 mt-1">
         <div class="container">
            <Form
               @submit="nextStep"
               :validation-schema="currentSchema"
               keep-values
               v-slot="{ values }"
               :initial-values="dataMedProv"
            >
            <!--
      <span class="modal__title tx-cl-white">Prestador ({{id}})</span>
            -->
               
               <div tabindex="1" onfocus="document.getElementById('last').focus()"></div>

               <template v-if="currentStep === 0">
                  <div class="row justify-content-between">
                     <div class=" col-12 col-md-5 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.cuit" 
                           :tabindex="6"
                           :id="'getCuit'"
                           :readonly="isUpdate"
                           @onBlur="onBlurCuit = true"
                           @onFocus="onBlurCuit = false"
                        />
                     </div>
                     <!--
                        class="border-0 " :class=" !item.active ? 'fst-italic fw-light' : ''"
                     <div class=" col-12 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.address" :tabindex="6"/>
                     </div>
                     <div class=" col-12 col-md-5 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.province" :tabindex="6"/>
                     </div>
                           :readonly="isBranch"
                     -->
                  </div>
               </template>

               <template v-if="currentStep === 1">
                  <div class="row justify-content-between">
                     <div class=" col-12 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.name" 
                           :tabindex="6" 
                           :readonly="isBranch"
                        />
                     </div>
                     <div class=" col-12 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.fantasyName" :tabindex="6"/>
                     </div>
                     <div class=" col-12 col-md-5 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.alias" :tabindex="6"/>
                     </div>
                     <div class=" col-12 col-md-5 p-0 m-0">
                        <select-field :fieldData="UpMedProvConfig.province" :tabindex="7" :options="provinces"/>
                     </div>
                     <div class=" col-12 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.address" :tabindex="6"/>
                     </div>
                  <!--
                        <common-field :fieldData="UpMedProvConfig.province" :tabindex="6"/>
                  </div>
                  <div class="row justify-content-between">
                  -->
                     <div class=" col-12 col-md-3 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.sCode" 
                           :tabindex="6" 
                        />
                     </div>
                     <div class=" col-12 col-md-3 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.tCode" 
                           :tabindex="6" 
                        />
                     </div>
                     <div class=" col-12 col-md-5 p-0 m-0 py-3">
                        <Field v-slot="{ field }" name="findByBranch" type="checkbox" :value="true" :unchecked-value="false">
                           <label>
                              <input type="checkbox" name="findByBranch" v-bind="field" 
                                 :value="true" 
                                 :disabled=" isBranch "
                              />
                              Busqueda por Lugar de Atención
                           </label>
                        </Field>
                     </div>
                     <div class=" col-12 col-md-3 p-0 m-0 py-3">
                        <Field v-slot="{ field }" name="active" type="checkbox" :value="true" :unchecked-value="false">
                           <label>
                              <input type="checkbox" name="active" v-bind="field" :value="true" />
                              Activo
                           </label>
                        </Field>
                     </div>
                     <!--
                     <div class=" col-12 col-md-6 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.status" 
                           :tabindex="6" 
                           :readonly="values.active"
                        />
                     </div>
                     -->
                     <div v-if="!values.active" class=" col-12 col-md-9 p-0 m-0">
                        <select-field :fieldData="UpMedProvConfig.status"
                           :options="status"
                           :tabindex="6" 
                        />
                     </div>
                  </div>
               </template>

               <template v-if="currentStep === 2">
                  <div class="row justify-content-between">
                     <div class=" col-12 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.shifts" :tabindex="6"/>
                     </div>
                     <div class=" col-12 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.phone" :tabindex="6"/>
                     </div>
                     <div class=" col-12 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.whatsApp" :tabindex="6"/>
                     </div>
                     <div class=" col-12 col-md-6 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.email" :tabindex="6"/>
                     </div>
                     <div class=" col-12 col-md-5 p-0 m-0">
                        <common-field :fieldData="UpMedProvConfig.webPage" :tabindex="6"/>
                     </div>
                  </div>
               </template>

               <div class="row border-top mt-2 p-0 justify-content-between">
                  <div class="d-flex justify-content-start pt-2 px-0 col-2">
                     <user-circle :circleUser="myCircle" /> <!--  class="col-2 mt-2"/> -->
                     <!--
                     <button v-if="currentStep != 0 && !showV310"
                           @click="prevStep(values)"
                     <button v-if="currentStep != lastStep && !showV310"
                     <button v-if="currentStep == lastStep && !showV310"
                           @click="updateVoucher()"
                     -->
                  </div>
                  <div class="d-flex justify-content-end pt-2 px-0 col-10">
                     <button v-if=" currentStep != 0"
                           type="button" 
                           :tabindex="currentLastTabIndex + 2" 
                           class="btn btn-outline-light btn-sm me-2" 
                           @click="prevStep(values)"
                           >
                        Anterior
                     </button>
                     <button v-if=" currentStep != lastStep "
                           type="submit" 
                           :tabindex="currentLastTabIndex + 3" 
                           class="btn btn-outline-light btn-sm me-2"
                           >
                        Siguiente
                     </button>
                     <button v-if=" currentStep == lastStep "
                           type="submit" 
                           :tabindex="2" 
                           :id="'first'" 
                           class="btn btn-outline-light btn-sm me-2"
                           >
                        Guardar
                     </button>
                     <button type="button" 
                           :tabindex="currentLastTabIndex + 4" 
                           class="btn btn-outline-light btn-sm" 
                           @click="beforeClose()"
                           id="lastima"
                           >
                        Salir
                     </button>
                     <div :tabindex="currentLastTabIndex + 5" onfocus="document.getElementById('first').focus()"></div>
                  </div>
               </div>
            </Form>
            <!--
            {{values}}
            {{dataMedProv}}
            -->
         </div>
      </div>
   </vue-final-modal>
</template>

<script>
import { ref, computed } from 'vue';
import { useStore } from 'vuex'
import { VueFinalModal } from 'vue-final-modal'
import { Form, Field, defineRule } from 'vee-validate';
import * as yup from 'yup';

import AnalyService from '../../analytics.service';
import WspService from '../../../workSpace/workSpace.service';

import CommonField from '../../../voucher310/components/CommonField.vue';
import SelectField from '../../../voucher310/components/SelectField.vue';
import UserCircle from '../../../../components/UserCircle.vue';

export default {

   components: {
      CommonField,
      Field,
      Form,
      SelectField,
      UserCircle,
      VueFinalModal
   },

   props: {
      id: {
         type: Number,
         default: 0
      },
      allData: {
         type: Object
      }
   },

   emits: [ 'cancel' ],

   setup( props, { emit }) {

      defineRule('drValidCuit', value => {

         if ( props.id == 0) {
            return validCuit( value )
         }
         return true

      });

      const cmpActive = ref(true)
      /*
      const cmpActive = computed(() => {
         return dataMedProv.value.active
      })
      */
      const currentLastTabIndex = computed(() => {
         return lastTabIndex[currentStep.value]
      })
      const currentSchema = computed(() => {
         return UpMedProvSchema[currentStep.value]
      })
      const currentStep = ref(0);
      const currentUserId = computed(() => {
         return store.state.auth.user.id
      })
      const dataMedProv = ref({})
      //const isBranch = ref(true)
      const isBranch = computed(() => {
         if ( dataMedProv.value.branch == 0 ) {
            return false
         }
         return true
      })
      const isUpdate = ref(false)
      const lastStep = ref(2)
      /*
      const lastStep = computed(() => {
         if ( dataMedProv.value.branch == 0 ) {
            return 1
         }
         return 2
      })
      */
      const lastTabIndex = [7, 3, 6, 3]
      const myCircle = ref({})
      const onBlurCuit = ref(false)
      const provinces = ref([])
      const status = ref([])
      const store = useStore()
      const UpMedProviderModal = ref(true)

      //let count = 0
      //let countp = 0
      //let countr = 0
      //
      function nextStep(values) {
         keepValues( values )
         setTimeout(() => { 
            //console.log(values)
            if (currentStep.value == lastStep.value ) {
               console.log('Done: ', JSON.stringify(dataMedProv.value, null, 2))
               AnalyService.updateMedicalProvider( dataMedProv.value )
                  .then(response => {
                     console.log( response.data )
                     emit('cancel')
                  })
                  .catch(error => {
                     console.log(error);
                     emit('cancel')
                  });
               //return
            } else {
               currentStep.value++
            }
         }, 100)
      }

      function prevStep( values ) {
         keepValues( values )
         if (currentStep.value <= 0) {
            return
         }
         currentStep.value--
      }

      const UpMedProvSchema = [
         {
            /*
            cuit( value ) {                       //cuit: yup.string(),  //'dfrValidCuil',
               if ( props.id == 0) {
                  return validCuit( value )
               }
               return true
            },
            */
            cuit: 'drValidCuit',
            //name: yup.string().required('Dato requerido!'),
         },
         {
            name: yup.string().required('Dato requerido!'),
            fantasyName: yup.string().required('Dato requerido!'),
            alias: yup.string().nullable(),
            province: yup.string().required('Dato requerido!'),
            address: yup.string().required('Dato requerido!'),
            sCode: yup.string().required('Dato requerido!'),
            tCode: yup.string(),
            active( value ) {
               //console.log(value)
               cmpActive.value = value
               return true
            },
            /*
            active: yup.boolean(),
            status: yup
               .string()
               .when("active", {
                  is: false,
                  then: yup.string().required('Dato requerido!')
               })
               if ( value == undefined || value < 1 ) {
                  return false
               }
            */
            
            status( value ) {
               //console.log(value)
               //console.log(cmpActive.value)
               if ( cmpActive.value ) {
                  return true
               } else {
                  if ( value == undefined ) {
                     return 'Dato requerido!'
                  }
                  return true
               }
            }
            
            //status: yup.string().required('Dato requerido!'),
         },
         {
            //phone: yup.string().email('Dirección de email inválida!')
            email: yup.string().email('Dirección de email inválida!').nullable()
         }
      ]
      //
      async function validCuit( value ) {
         
         if ( !onBlurCuit.value ) {
            //return true
         }

         if ( value === undefined ) { return 'Dato requerido!' }
         if ( isNaN( value ) ) { return 'Debe ser un número!' }
         if ( value < 20000000000 ) { return 'Número de CUIT inválido!' }
         if ( value > 40000000000 ) { return 'Número de CUIT inválido!' }
         if ( parseInt( value ) != value ) { return 'Debe ser un número entero!' }
         
         //count++
         let promise = new Promise(( resolve ) => {
            //countp++
            //console.log(count, countp, countr, new Date().getTime(), 'entro al promise')
            AnalyService.medicalProviderExists( value )
               .then(response => {
                  //countr++
                  let result = response.data
            //console.log(count, countp, countr, new Date().getTime(), 'obtengo el result')
                  if ( result.nextBranchNumber == 0) {
                     //isBranch.value = false
                     dataMedProv.value.findByBranch = false
                  } else {
                     dataMedProv.value.name = result.name
                     dataMedProv.value.findByBranch = result.findByBranch
                  }
                  dataMedProv.value.branch = result.nextBranchNumber
                  dataMedProv.value.cuit = value
            //.log(count, countp, countr, new Date().getTime(), 'justo antes del resolve')
            //console.log(count, countp, countr, new Date().getTime(), JSON.stringify(dataMedProv.value, null, 2))
            //count++
                  resolve( true )
               })
               .catch(error => {
                  console.log(error);
                  resolve( 'Error de red!' )
               });
         })

         
            //console.log(count, countp, countr, new Date().getTime(), 'justo antes del return await')
            //console.log(count, countp, countr, new Date().getTime(), JSON.stringify(dataMedProv.value, null, 2))
         //return await promise
         let salida =  await promise
         return salida
         /*
         let promise = new Promise(( resolve ) => {
            AnalyService.medicalProviderExists( value )
               .then(response => {
                  resolve( response.data )
               })
               .catch(error => {
                  console.log(error);
                  return 'Error de red!'
               });
         })

         let result = await promise
         if ( result.nextBranchNumber == 0) {
            isBranch.value = false
            dataMedProv.value.findByBranch = false
         } else {
            dataMedProv.value.name = result.name
            dataMedProv.value.findByBranch = result.findByBranch
         }
         dataMedProv.value.branch = result.nextBranchNumber
         
         return true
         */
      }
      //
      const UpMedProvConfig = {
         cuit: {
            name: 'cuit',
            label: 'C.U.I.T.',
            type: 'text'
         },
         name: {
            name: 'name',       //'name',
            label: 'Razón Social',
            type: 'text'
         },
         tCode: {
            name: 'tCode',
            label: 'Código TechMedica',
            type: 'text'
         },
         sCode: {
            name: 'sCode',
            label: 'Código Selectum',
            type: 'text'
         },
         fantasyName: {
            name: 'fantasyName',
            label: 'Nombre del Lugar de Atención',
            type: 'text'
         },
         alias: {
            name: 'alias',
            label: 'Alias',
            type: 'text'
         },
         province: {
            name: 'province',
            label: 'Provincia',
            type: 'text'
         },
         address: {
            name: 'address',
            label: 'Dirección',
            type: 'text'
         },
         active: {
            name: 'active'
         },
         status: {
            name: 'status',
            label: 'Motivo de Inactividad',
            type: 'text'
         },
         shifts: {
            name: 'shifts',
            label: 'Turnos',
            type: 'text'
         },
         phone: {
            name: 'phone',
            label: 'Teléfonos',
            type: 'text'
         },
         whatsApp: {
            name: 'whatsApp',
            label: 'WhatsApp',
            type: 'text'
         },
         email: {
            name: 'email',
            label: 'Correo Electrónico',
            type: 'text'
         },
         webPage: {
            name: 'webPage',
            label: 'Página Web',
            type: 'text'
         },
      }
      //
      function beforeClose() {
         //if (confirm("Si sale se perderan los datos ingresados.") == true) {
            emit('cancel')
         //}
      }

      function beforeOpen() {
         onBlurCuit.value = false
         //isBranch.value = true
         isUpdate.value = false
         dataMedProv.value.id = props.id
         if ( props.id == 0) {
            dataMedProv.value.active = true
         } else {
            dataMedProv.value = props.allData
            isUpdate.value = true
         }

         AnalyService.findProvincesStates()
         .then(response => {
            provinces.value = [
               { value: '', name: 'Seleccione una Provincia', disabled: true },
                ...response.data
               ]
         })
         .catch(error => {
            console.log(error);
         })

         AnalyService.findStatus( 'MPV' )
         .then(response => {
            status.value = [
               { value: '', name: 'Seleccione un Motivo', disabled: true },
                ...response.data
               ]
         })
         .catch(error => {
            console.log(error);
         })
      }

      function keepValues( values ) {
         for (let key in values) {
            dataMedProv.value[key] = values[key]
            if (values[key] == "") {
               if ( typeof values[key] != "boolean" ) {
                  delete dataMedProv.value[key]
               }
            }
         }
      }

      function opened() {
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            myCircle.value = response.data
         })
         .catch(error => {
            console.log(error);
         })
         document.getElementById('getCuit').focus()
      }

      return {
         beforeClose, beforeOpen,
         currentLastTabIndex, currentSchema, currentStep,
         dataMedProv,
         isBranch, isUpdate,
         lastStep,
         myCircle,
         nextStep,
         onBlurCuit, opened,
         prevStep, provinces,
         status,
         UpMedProvConfig, UpMedProviderModal
      }
   },
}
</script>

<style scoped>
::v-deep(.UpMedProv-modal-modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /*align-items: center;*/
}
::v-deep(.UpMedProv-modal-content) {
  /*
  background: #fff;
  padding: 0.75rem;
  width: auto;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 350px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  /*background-color: #9E9E9E ;*/
  background-color: hsl(0, 45%, 63%) ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.tx-cl-white {
   color: white;
}
.up-medProv {
  /*background-color: #9E9E9E ;*/
  background-color: hsl(0, 45%, 63%) ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
</style>